const PATH = {
  home: '/',
  reservation: '/reservation',
  bpay: '/bpay',
  community: '/community',
  schedule: '/schedule',
  me: '/me',
  alarm: '/alarm',
  myTicket: '/my-ticket',
  registerCenter: 'register-center',
  setting: '/setting',
  login: '/login',
} as const;

export { PATH };
